import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Text,
} from "@chakra-ui/react";

/**
 * BufferInput Component
 * Buffer minutes input with helper text
 */
export default function BufferInput({ value, onChange, isReadOnly = false }) {
  return (
    <FormControl isRequired>
      <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
        Buffer (minutes)
      </FormLabel>
      <Input
        type="number"
        min="0"
        max="120"
        value={value}
        onChange={(e) => onChange(Math.max(0, Math.min(120, parseInt(e.target.value) || 0)))}
        size="lg"
        borderWidth="2px"
        isReadOnly={isReadOnly}
        bg={isReadOnly ? "gray.50" : "white"}
      />
      <Text fontSize="xs" color="gray.500" mt={1}>
        Extra travel time cushion before/after this job
      </Text>
    </FormControl>
  );
}
